import { Container, Grid } from "@material-ui/core";
import React from "react";
import ExchangeBoardTable from "./ExchangeBoardTable";

function ExchangeBoard() {
  return (
    <Container fixed>
      <Grid container>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <ExchangeBoardTable />
        </Grid>
      </Grid>
    </Container>
  );
}

export default ExchangeBoard;
